import { render, staticRenderFns } from "./studying.vue?vue&type=template&id=cd7b2e34&scoped=true"
import script from "./studying.vue?vue&type=script&lang=js"
export * from "./studying.vue?vue&type=script&lang=js"
import style0 from "./studying.vue?vue&type=style&index=0&id=cd7b2e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7b2e34",
  null
  
)

export default component.exports